import { useCallback, useRef, useState } from 'react';
import { CreateInstrumentItem, fundingApi } from '../../../services/fundingApi';
import { DuplicateRow, buildDuplicateRows } from './duplicateRows';

export interface DuplicateModalState {
    show: boolean;
    rows: DuplicateRow[];
}

const CLOSED: DuplicateModalState = { show: false, rows: [] };

export const useDuplicateConfirmation = () => {
    const [modal, setModal] = useState<DuplicateModalState>(CLOSED);
    const pendingDecision = useRef<((proceed: boolean) => void) | null>(null);

    const confirm = useCallback(async (items: CreateInstrumentItem[]): Promise<boolean> => {
        let rows: DuplicateRow[];
        try {
            const result = await fundingApi.checkDuplicateInstruments(items);
            if (!result.ok) return true;
            rows = buildDuplicateRows(result.data, items);
        } catch {
            return true;
        }
        if (rows.length === 0) return true;

        return new Promise<boolean>((resolve) => {
            pendingDecision.current = resolve;
            setModal({ show: true, rows });
        });
    }, []);

    const decide = useCallback((proceed: boolean) => {
        setModal(CLOSED);
        pendingDecision.current?.(proceed);
        pendingDecision.current = null;
    }, []);

    return { modal, confirm, decide };
};
